import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Alert } from "react-bootstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import DemonstrativoAI from "./TiposDemonstrativos/DemonstrativoAI";
import DemonstrativoAM from "./TiposDemonstrativos/DemonstrativoAM";
import DemonstrativoD from "./TiposDemonstrativos/DemonstrativoD";
import DemonstrativoE from "./TiposDemonstrativos/DemonstrativoE";
import DemonstrativoJ1 from "./TiposDemonstrativos/DemonstrativoJ1";
import DemonstrativoM from "./TiposDemonstrativos/DemonstrativoM";
import DemonstrativoP from "./TiposDemonstrativos/DemonstrativoP";
import DemonstrativoQ from "./TiposDemonstrativos/DemonstrativoQ";
import DemonstrativoR from "./TiposDemonstrativos/DemonstrativoR";
import DemonstrativoS from "./TiposDemonstrativos/DemonstrativoS";
import DemonstrativoV from "./TiposDemonstrativos/DemonstrativoV";
import useVerificaResultado from "./hooks/useVerificaResultado";
import useSomenteConsultaOs from "../hooks/useSomenteConsultaOs";
// import useMontarLogica from "./hooks/useMontarLogica";

const validationSchema = Yup.object().shape({
  sqAcaoFiscal: Yup.string().default(""),
  sqItemOcorrencia: Yup.string().default(""),
  sqItem: Yup.string().default(""),
  dsItem: Yup.string().default(""),
  nuItem: Yup.string().default(""),
  txReferencia: Yup.string().test(
    "dt-ref",
    "Referência deve estar no formato mês/ano (ex. 01/2023)",
    (value, dados) => {
      const regexData = /^(0[1-9]|1[0-2])\/\d{4}$/;

      if (
        regexData.test(value) === false &&
        dados.parent.tipoDetalhamento !== "M" &&
        dados.parent.tipoDetalhamento !== "AI"
      ) {
        return false;
      }

      return true;
    },
  ),
  dtVencimento: Yup.string().default(""),
  dtEmissao: Yup.string().default(""),
  vlApurado: Yup.string().default(""),
  vlDeclarado: Yup.string().default(),
  vlIcmsRecolhido: Yup.string().default(""),
  valorTotalNota: Yup.string().default(""),
  sequencialUf: Yup.string().default(""),
  siglalUf: Yup.string().default(""),
  sgCodigoReceita: Yup.string().default(""),
  vlBaseCalculo: Yup.string().default(""),
  vlCredito: Yup.string().default(""),
  vlIcmsDestacado: Yup.string().default(""),
  pcIcmsAuditor: Yup.string().default(""),
  pcAgregadoAuditor: Yup.string().default(""),
  vlDifAliquota: Yup.string().default(""),
  vlIcms: Yup.string().default(""),
  vlIcmsVisivel: Yup.string().default(""),
  txJustificativa: Yup.string().default(""),
  vlIcmsSubst: Yup.string().default(""),
  txChave: Yup.string()
    .nullable()
    .test("chave", "Chave deve possuir 44 caracteres", (value, dados) => {
      if (
        (value?.length > 0 || value !== null || value !== "") &&
        (dados.parent.tipoDetalhamento === "M" ||
          dados.parent.tipoDetalhamento === "AI" ||
          dados.parent.tipoDetalhamento === "AM")
      ) {
        if (value?.length < 44 || value?.length > 44) {
          return false;
        }
      }
      return true;
    }),
  vlCMV: Yup.string().default(""),
  vlVendasArbitradas: Yup.string().default(""),
  vlVendasDeclaradas: Yup.string().default(""),
  vlOmissaoSaidas: Yup.string().default(""),
  pcVendas: Yup.string().default(""),
  vlArrolamento: Yup.string().default(""),
  nuCnpjRemet: Yup.string()
    .default("")
    .nullable()
    .test("CnpjCpf", "Digite CNPJ/CPF válido", (value, dados) => {
      if (
        value?.length > 0 &&
        value?.length !== 11 &&
        value?.length !== 14 &&
        (dados.parent.tipoDetalhamento === "M" ||
          dados.parent.tipoDetalhamento === "AI" ||
          dados.parent.tipoDetalhamento === "AM")
      ) {
        return false;
      }

      return true;
    }),
  codigoFiscalOperacao: Yup.string().default(""),
  vlProduto: Yup.string().default(""),
  vlIcmsCalculado: Yup.string().default(""),
  vlMultaOcorrencia: Yup.string().default(""),
  qtItem: Yup.string().default(""),
  cdDocumento: Yup.string().default(""),
  tpCategoria: Yup.string().default("LF"),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  if (key === "tpCategoria") initialValues[key] = "LF";
  else initialValues[key] = "";
});

const FormDemonstrativos = ({ tipoDetalhamento, sqItemOcorrencia, sqAcaoFiscal, dadosOcorrencia, voltarListagem }) => {
  const { request: submitRequest, data: submitData, errors: submitErrors, isLoading: submitIsLoading } = useApiClient();
  const [show, setShow] = useState(false);
  const history = useHistory();

  const { verificaResultado, existe } = useVerificaResultado({ sqAcaoFiscal: sqAcaoFiscal });

  const somenteConsulta = useSomenteConsultaOs();

  useEffect(() => {
    if (sqAcaoFiscal !== null && sqAcaoFiscal !== "") {
      verificaResultado();
    }
  }, [sqAcaoFiscal, verificaResultado]);

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      const parametros = {
        sqAcaoFiscal,
        sqItemOcorrencia,
        sqItem: values.sqItem,
        dsItem: values.dsItem,
        txReferencia: values.txReferencia,
        dtVencimento: values.dtVencimento,
        dtEmissao: values.dtEmissao,
        vlApurado: values.vlApurado,
        vlDeclarado: values.vlDeclarado,
        vlIcmsRecolhido: values.vlIcmsRecolhido,
        nuItem: values.nuItem,
        valorTotalNota: values.valorTotalNota,
        sequencialUf: values.sequencialUf,
        sgFiscalOperacao: values.sgFiscalOperacao,
        vlBaseCalculo: values.vlBaseCalculo,
        vlCredito: values.vlCredito,
        vlIcmsDestacado: values.vlIcmsDestacado,
        pcIcmsAuditor: values.pcIcmsAuditor,
        pcAgregadoAuditor: values.pcAgregadoAuditor,
        vlDifAliquota: values.vlDifAliquota,
        vlIcms: values.vlIcms,
        txJustificativa: values.txJustificativa,
        vlIcmsSubst: values.vlIcmsSubst,
        txChave: values.txChave,
        vlCMV: values.vlCMV,
        pcVendas: values.pcVendas,
        vlVendasArbitradas: values.vlVendasArbitradas,
        vlVendasDeclaradas: values.vlVendasDeclaradas,
        vlOmissaoSaidas: values.vlOmissaoSaidas,
        vlArrolamento: values.vlArrolamento,
        nuCnpjRemet: values.nuCnpjRemet,
        codigoFiscalOperacao: values.codigoFiscalOperacao,
        vlProduto: values.vlProduto,
        vlIcmsCalculado: values.vlIcmsCalculado,
        vlMultaOcorrencia: values.vlMultaOcorrencia,
        qtItem: values.qtItem,
        cdDocumento: values.cdDocumento,
      };
      if (values.sqItem > 0) {
        submitRequest(apiRoutes.fiscalizacao.ocorrencia.alterarDemonstrativo, parametros);
      } else {
        submitRequest(apiRoutes.fiscalizacao.ocorrencia.incluirDemonstrativo, parametros);
      }
    },
  });

  const { setSubmitting, setErrors, errors } = formik;

  useEffect(() => {
    if (!submitIsLoading) setSubmitting(false);

    if (submitErrors) {
      setSubmitting(false);
      setShow(true);
    }

    if (submitData) {
      setShow(false);
      setErrors({ ...errors, ...submitErrors });
      toast.success("Item do demonstrativo salvo com sucesso.");
      voltarListagem();
    }
  }, [setSubmitting, setErrors, submitData, submitErrors, submitIsLoading, errors, voltarListagem]);

  const tiposDetalhamentoQ = ["Q", "Q1", "Q2", "Q3"];
  const tiposDetalhamentoD = ["D", "D1", "D2"];
  return (
    <>
      <div className="card-body">
        <Alert variant="danger" show={show} onClose={() => setShow(false)} dismissible>
          {" "}
          {submitErrors?.message}{" "}
        </Alert>
        <Form noValidate onSubmit={formik.handleSubmit}>
          {(() => {
            const tipo = tipoDetalhamento;
            if (tiposDetalhamentoQ.includes(tipo)) {
              return (
                <DemonstrativoQ
                  history={history}
                  sqItemOcorrencia={sqItemOcorrencia}
                  sqAcaoFiscal={sqAcaoFiscal}
                  dadosOcorrencia={dadosOcorrencia}
                  tipoDetalhamento={tipoDetalhamento}
                  formik={formik}
                />
              );
            }
            if (tiposDetalhamentoD.includes(tipo)) {
              return (
                <DemonstrativoD
                  history={history}
                  sqItemOcorrencia={sqItemOcorrencia}
                  sqAcaoFiscal={sqAcaoFiscal}
                  dadosOcorrencia={dadosOcorrencia}
                  tipoDetalhamento={tipoDetalhamento}
                  formik={formik}
                />
              );
            }
            switch (tipo) {
              case "AI":
                return (
                  <DemonstrativoAI
                    history={history}
                    sqItemOcorrencia={sqItemOcorrencia}
                    sqAcaoFiscal={sqAcaoFiscal}
                    dadosOcorrencia={dadosOcorrencia}
                    tipoDetalhamento={tipoDetalhamento}
                    formik={formik}
                  />
                );

              case "AM":
                return (
                  <DemonstrativoAM
                    history={history}
                    sqItemOcorrencia={sqItemOcorrencia}
                    sqAcaoFiscal={sqAcaoFiscal}
                    dadosOcorrencia={dadosOcorrencia}
                    tipoDetalhamento={tipoDetalhamento}
                    formik={formik}
                  />
                );
              case "E":
                return (
                  <DemonstrativoE
                    history={history}
                    sqItemOcorrencia={sqItemOcorrencia}
                    sqAcaoFiscal={sqAcaoFiscal}
                    dadosOcorrencia={dadosOcorrencia}
                    tipoDetalhamento={tipoDetalhamento}
                    formik={formik}
                  />
                );

              case "J1":
                return (
                  <DemonstrativoJ1
                    history={history}
                    sqItemOcorrencia={sqItemOcorrencia}
                    sqAcaoFiscal={sqAcaoFiscal}
                    dadosOcorrencia={dadosOcorrencia}
                    tipoDetalhamento={tipoDetalhamento}
                    formik={formik}
                  />
                );

              case "M":
                return (
                  <DemonstrativoM
                    history={history}
                    sqItemOcorrencia={sqItemOcorrencia}
                    sqAcaoFiscal={sqAcaoFiscal}
                    dadosOcorrencia={dadosOcorrencia}
                    tipoDetalhamento={tipoDetalhamento}
                    formik={formik}
                  />
                );

              case "P":
                return (
                  <DemonstrativoP
                    history={history}
                    sqItemOcorrencia={sqItemOcorrencia}
                    sqAcaoFiscal={sqAcaoFiscal}
                    dadosOcorrencia={dadosOcorrencia}
                    tipoDetalhamento={tipoDetalhamento}
                    formik={formik}
                  />
                );
              case "R":
                return (
                  <DemonstrativoR
                    history={history}
                    sqItemOcorrencia={sqItemOcorrencia}
                    sqAcaoFiscal={sqAcaoFiscal}
                    dadosOcorrencia={dadosOcorrencia}
                    tipoDetalhamento={tipoDetalhamento}
                    formik={formik}
                  />
                );
              case "R2":
                return (
                  <DemonstrativoR
                    history={history}
                    sqItemOcorrencia={sqItemOcorrencia}
                    sqAcaoFiscal={sqAcaoFiscal}
                    dadosOcorrencia={dadosOcorrencia}
                    tipoDetalhamento={tipoDetalhamento}
                    formik={formik}
                  />
                );

              case "S":
                return (
                  <DemonstrativoS
                    history={history}
                    sqItemOcorrencia={sqItemOcorrencia}
                    sqAcaoFiscal={sqAcaoFiscal}
                    dadosOcorrencia={dadosOcorrencia}
                    tipoDetalhamento={tipoDetalhamento}
                    formik={formik}
                  />
                );
              case "V":
                return (
                  <DemonstrativoV
                    history={history}
                    sqItemOcorrencia={sqItemOcorrencia}
                    sqAcaoFiscal={sqAcaoFiscal}
                    dadosOcorrencia={dadosOcorrencia}
                    tipoDetalhamento={tipoDetalhamento}
                    formik={formik}
                  />
                );
              default:
                return null;
            }
          })()}
        </Form>
      </div>
      <div className="card-body">
        <Row>
          <Col>
            {!somenteConsulta && (
              <Button
                variant="primary"
                className="mr-3"
                size="md"
                onClick={formik.handleSubmit}
                disabled={existe === "S"}
              >
                Salvar
              </Button>
            )}

            {"    "}
            {!formik.isSubmitting && !somenteConsulta && (
              <Button variant="light" className="mr-3" size="md" onClick={formik.handleReset} disabled={existe === "S"}>
                Limpar
              </Button>
            )}
            {"    "}
            {!formik.isSubmitting && (
              <Button variant="danger" size="md" onClick={voltarListagem} disabled={existe === "S"}>
                Cancelar
              </Button>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default FormDemonstrativos;
